/* @flow */
import type { TranslationType } from '../helpers/i18n'

export type ValueFailureType = TranslationType | Object
export type ValueSuccessType = TranslationType | Object | number | boolean
export type ValidationType = Success | Failure

/**
 * Represents a failed validation.
 */
class Failure {
  value: ValueFailureType
  isFailure = true

  /**
   * @constructor
   * @param {Err} value - An array of error objects.
   */
  constructor(value: ValueFailureType) {
    this.value = value
  }

  orElse(f: (ValueFailureType) => Failure): Failure {
    return f(this.value)
  }

  or(validation: ValidationType) {
    return validation
  }

  and(_validation: ValidationType) {
    return this
  }

  cata(pattern: Object): ?string {
    return pattern.Failure(this.value)
  }
}

/**
 * Represents a successfull validation.
 */
class Success {
  value: ValueSuccessType
  isSuccess = true

  /**
   * @constructor
   * @param {*} a - A value that has been successfully validated.
   */
  constructor(value: ValueSuccessType) {
    this.value = value
  }

  orElse(_f: (ValueFailureType) => ValueFailureType): Success {
    return this
  }

  or(_validation: ValidationType): Success {
    return this
  }

  and(validation: ValidationType) {
    return validation
  }

  cata(pattern: Object): ?string {
    return pattern.Success(this.value)
  }
}

export { Success, Failure }
